import { render, staticRenderFns } from "./PriceComparison.vue?vue&type=template&id=e01ce0f8&scoped=true"
import script from "./PriceComparison.vue?vue&type=script&lang=js"
export * from "./PriceComparison.vue?vue&type=script&lang=js"
import style0 from "./PriceComparison.vue?vue&type=style&index=0&id=e01ce0f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01ce0f8",
  null
  
)

export default component.exports